export default __webpack_public_path__ + "static/media/mailgun_logo.032f5e7d.webp";